<template>
    <div class="bg-white pa-4 rounded-lg h-100 overflow-y-auto">
        <v-col xl="6" lg="7" md="9" cols="12">
            <v-stepper-vertical color="secondary" eager flat :items="steps" v-model="stepper">
                <template #item.1>
                    <v-form ref="step1Form">
                        <switch-input v-model="form.status" label="وضعیت"></switch-input>
                        <v-text-field
                            label="* عنوان"
                            v-model="form.name"
                            :rules="$validation('required')"
                        ></v-text-field>
                        <v-textarea
                            no-resize
                            rows="3"
                            label="توضیحات"
                            model-value=""
                            v-model="form.description"
                            :rules="$validation()"
                        ></v-textarea>
                    </v-form>
                </template>
                <template #item.2>
                    <p class="text-grey-darken-2 font-medium text-small mb-6">قوانین SLA بر روی تیکت‌های دریافتی با شرایط زیر اعمال خواهند شد.</p>
                    <v-form ref="step2Form">
                        <v-autocomplete
                            :items="branches"
                            v-if="$auth.user.full_admin"
                            v-model='form.branch_id'
                            item-title="name"
                            item-value="id"
                            label="* شعبه گیرنده تیکت"
                            no-data-text="موردی پیدا نشد!"
                            @update:modelValue="form.actions = []"
                            :rules="$validation('required:' + ($auth.user.full_admin ? 1 : 0))"
                        ></v-autocomplete>
                        <v-autocomplete
                            :items="departments"
                            v-model='form.department_id'
                            item-title="name"
                            item-value="id"
                            label="* دپارتمان گیرنده تیکت"
                            no-data-text="موردی پیدا نشد!"
                            @update:modelValue="departmentChange"
                            :rules="$validation('required')"
                        ></v-autocomplete>
                        <v-select
                            :items="workingshifts"
                            v-model='form.workingshifts'
                            item-title="name"
                            item-value="id"
                            label="شیفت کاری"
                            no-data-text="موردی پیدا نشد!"
                            :disabled='!form.department_id'
                            multiple
                            clearable
                            :rules="$validation()"
                        >
                            <template #prepend-item>
                                <toggle-select-all @clicked="$text.toggleSelectAll('form.workingshifts' , 'workingshifts', $data)" :items='form.workingshifts' :all='workingshifts'></toggle-select-all>
                            </template>
                        </v-select>
                        <v-select
                            :items="ticketCategories"
                            v-model='form.ticket_categories'
                            item-title="name"
                            item-value="id"
                            label="دسته‌بندی موضوعی"
                            no-data-text="موردی پیدا نشد!"
                            :disabled='!form.department_id'
                            multiple
                            clearable
                            :rules="$validation()"
                        >
                            <template #prepend-item>
                                <toggle-select-all @clicked="$text.toggleSelectAll('form.ticket_categories' , 'ticketCategories', $data)" :items='form.ticket_categories' :all='ticketCategories'></toggle-select-all>
                            </template>
                        </v-select>
                        <v-select
                            :items="importances"
                            v-model='form.importances'
                            item-title="name"
                            item-value="id"
                            label="میزان اهمیت تیکت"
                            no-data-text="موردی پیدا نشد!"
                            :disabled='!form.department_id'
                            multiple
                            clearable
                            :rules="$validation()"
                        >
                            <template #prepend-item>
                                <toggle-select-all @clicked="$text.toggleSelectAll('form.importances' , 'importances', $data)" :items='form.importances' :all='importances'></toggle-select-all>
                            </template>
                        </v-select>
                        <v-select
                            :items="customerLevels"
                            v-model='form.customer_levels'
                            item-title="name"
                            item-value="id"
                            label="سطح مشتری"
                            no-data-text="موردی پیدا نشد!"
                            :disabled='!form.department_id'
                            multiple
                            clearable
                            :rules="$validation()"
                        >
                            <template #prepend-item>
                                <toggle-select-all @clicked="$text.toggleSelectAll('form.customer_levels' , 'customerLevels', $data)" :items='form.customer_levels' :all='customerLevels'></toggle-select-all>
                            </template>
                        </v-select>
                    </v-form>
                </template>
                <template #item.3>
                    <p class="d-block mb-6 font-weight-medium text-small text-grey-darken-1">با تنظیم گزینه‌های زیر، بازه زمانی مجاز برای ثبت اولین پاسخ و بسته شدن تیکت تعیین می‌گردد. <br>دقت نمایید که مهلت زمانی بسته شدن تیکت می‌باید از مهلت زمانی ثبت اولین پاسخ بیشتر باشد.</p>
                    <v-form ref="step3Form">
                        <time-picker-input
                            class="ms-1"
                            v-model="form.closing_time"
                            label="مهلت بسته شدن تیکت"
                            required
                            clearable
                            @update:modelValue="form.actions = [];"
                        ></time-picker-input>
                        <time-picker-input
                            v-model="form.first_reply_time"
                            label="مهلت اولین پاسخ تیکت"
                            required
                            clearable
                            @update:modelValue="form.actions = []"
                        ></time-picker-input>
                    </v-form>
                </template>
                <template #item.4>
                    <p class="text-small font-weight-medium text-grey-darken-1 mb-6">عملکردهای پیشرفته در نرم افزار هلپیکال، ضریب موفقیت اجرای قوانین SLA را افزایش می‌دهند. <br>این موضوع از طریق مکانیزم ارسال هشدار یا انتقال تیکت به سایر کاربران پیش از رسیدن به مهلت‌های زمانی صورت خواهد پذیرفت.</p>
                    <v-btn color="primary" @click="newAction" :disabled="!users.length">عملکرد جدید</v-btn>
                    <workingShiftCard
                        :lists="form.actions"
                        :showDetails='false'
                        :reRender='actionCardReRender'
                        labelKey="label"
                        icon="icon-bell-ring"
                        @editCard="editAction"
                        @deleteCard="deleteAction"
                    ></workingShiftCard>
                </template>
                <template #title="{title}">
                    <span class="text-meta cursor-pointer font-weight-regular">{{title}}</span>
                </template>
                <template #actions="{step}">
                    <div class="mt-3">
                        <v-btn @click="changeStep(step + 1)" color="success" :loading="loading">{{ step == steps.length ? 'ثبت اطلاعات' : 'ثبت و ادامه'}}</v-btn>
                        <v-btn v-if="step > 1" @click="changeStep(step - 1)" color="error" class="ms-3" variant="text" :disabled="loading">بازگشت</v-btn>
                    </div>
                </template>
            </v-stepper-vertical>
        </v-col>
        <v-dialog v-model="dialog" width="500" persistent>
            <v-card tile>
                <v-toolbar color="white">
                    <v-toolbar-title class="text-primary">عملکرد جدید</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialog = false">
                        <v-icon size="23" color="primary">close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-divider></v-divider>
                <v-form @submit.prevent="$refs.actionForm.isValid && acceptAction()" ref="actionForm" class="px-6 mt-2 text-grey-darken-2">
                    <p class="text-small mb-6">با تعریف عملکرد جدید از طریق فرم زیر، امکان ارسال هشدار یا انتقال تیکت به سایر کاربران پیش از رسیدن به مهلت‌های زمانی تنظیم شده در مرحله زمانبندی امکان‌پذیر خواهد بود.</p>
                    <v-select
                        :items="[{name: 'اولین پاسخ تیکت', id: false}, {name: 'بسته شدن تیکت', id: true}]"
                        v-model="local_action.action"
                        item-title="name"
                        item-value="id"
                        label="* نوع رویداد"
                        no-data-text="موردی پیدا نشد!"
                        :rules="$validation('required')"
                        @update:modelValue="local_action.action_time = null"
                    ></v-select>
                    <div class="mb-6 mt-2 pb-2 rounded position-relative" style="border: 1px solid grey;">
                        <p color="grey" class="position-absolute bg-white text-grey px-1" style="top:-12px;right:5px;font-size: 0.65rem">مهلت باقی مانده</p>
                        <time-picker-input
                            required
                            v-model="local_action.action_time"
                        ></time-picker-input>
                    </div>
                    <v-autocomplete
                        :items="[{name: 'اطلاع رسانی', id: false},{name: 'انتقال تیکت', id: true}]"
                        v-model="local_action.operation"
                        item-title="name"
                        item-value="id"
                        label="* انتخاب عملکرد"
                        no-data-text="موردی پیدا نشد!"
                        :rules="$validation('required')"
                        @update:modelValue="local_action.users = []"
                    ></v-autocomplete>
                    <v-select
                        v-if="local_action.operation === false"
                        :items="[{id: 'email',name: 'Email'}, {id: 'sms',name: 'SMS'}, {id: 'telegram',name: 'Telegram'}, {id: 'webpush',name: 'Desktop notification'}, {id: 'webhook',name: 'Webhook'}]"
                        v-model="local_action.notification_types"
                        item-title="name"
                        item-value="id"
                        label="* نحوه اطلاع رسانی"
                        no-data-text="موردی پیدا نشد!"
                        multiple
                        :rules="$validation('required:' + (local_action.operation ? 1 : 0))"
                    ></v-select>
                    <v-select
                        :items="users"
                        v-model="local_action.users"
                        item-title="name"
                        item-value="id"
                        label="* ارسال به"
                        no-data-text="موردی پیدا نشد!"
                        :multiple='!local_action.operation'
                        :rules="$validation('required')"
                    ></v-select>
                    <v-card-actions class="pb-4 px-5">
                        <v-btn type="submit" color="success" variant="flat">ثبت اطلاعات</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="error" @click="dialog = false" class="ms-2" variant="text">بستن</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { VStepperVertical } from 'vuetify/labs/VStepperVertical'
export default {
    title: "ایجاد",
    components: {
        VStepperVertical,
    },
    validate(context) {
        return (context.auth.user.full_admin || context.auth.user.branch_admin) && context.system.license.features.ticket_sla;
    },
    data() {
        return {
            loading: false,
            actionCardReRender: false,
            dialog: false,
            steps: [
                { title: 'تعاریف اولیه', value: 1},
                { title: 'شرایط اجرای قوانین', value: 2},
                { title: 'زمانبندی', value: 3},
                { title: 'عملکردهای پیشرفته', value: 4},
            ],
            stepper: 1,
            form: {
                name: null,
                description: null,
                branch_id: null,
                status: true,
                department_id: null,
                workingshifts: [],
                ticket_categories: [],
                importances: [],
                customer_levels: [],
                closing_time: null,
                first_reply_time: null,
                actions: [],
            },
            //!---step2
            branches: [],
            departments: [],
            workingshifts: [],
            ticketCategories: [],
            importances: [],
            customerLevels: [],
            //!---step4
            users: [],
            local_action: {
                name: null,
                action: null,
                operation: null,
                action_time: null,
                notification_types: [],
                users: [],
            },
        };
    },
    methods: {
        async changeStep(step) {
            for (let i = 1; i < step; i++)
                if (this.$refs[`step${i}Form`] && !(await this.$refs[`step${i}Form`]?.validate())?.valid)
                    return this.stepper = i;
            if (step <= this.steps.length)
                this.stepper = step;
            else
                this.submit();
        },
        resetForms() {
            for (let i = 0; i < 5; i++)
                if (this.$refs[`step${i}Form`])
                    this.$refs[`step${i}Form`].resetValidation()
        },
        departmentChange(value) {
            this.form.workingshifts = [];
            this.form.ticket_categories = [];
            this.form.actions = [];
            this.workingshifts = this.departments.find((x) => x.id == value).workingshifts;
            this.ticketCategories = this.$system.ticketCategories.filter((x) => x.department_id == value);
            this.ticketCategories.push({name:'سایر',id:'other'})
            this.users = this.$auth.user.to_departments.find((x) => x.id == value) ? this.$auth.user.to_departments.find((x) => x.id == value).users : [];
            this.users = this.users.concat(this.$auth.user.to_departments.find((x) => x.id == this.$system.managers_department.id) ? this.$auth.user.to_departments.find((x) => x.id == this.$system.managers_department.id).users : []);
            if (this.$auth.user.full_admin)
                this.users = this.users.filter((x) => x.branch_id == this.form.branch_id || x.branch_id == -1);
            this.users.unshift({id: this.$auth.user.id, name: this.$auth.user.name})
            this.resetForms();
        },
        acceptAction() {
            this.local_action.label = `${this.local_action.action_time} مانده به ${this.local_action.action ? 'بسته شدن تیکت' : 'اولین پاسخ تیکت'}`;
            if (Object.hasOwn(this.local_action, 'id'))
                this.form.actions[this.form.actions.findIndex(x => x.id == this.local_action.id)] = {...this.local_action};
            else
                this.form.actions.push({id: Math.max(this.form.actions.map(x => x.id) + 1), ...this.local_action });
            this.actionCardReRender = !this.actionCardReRender;
            this.dialog = false;
        },
        deleteAction(id) {
            this.form.actions.splice(this.form.actions.findIndex((x) => x.id == id), 1);
        },
        newAction() {
            this.local_action = {
                label: null,
                action: null,
                operation: null,
                action_time: null,
                notification_types: [],
                users: [],
            };
            if (this.$refs.actionForm)
                this.$refs.actionForm.resetValidation();
            this.dialog = true;
        },
        editAction(id) {
            this.local_action = JSON.parse(JSON.stringify(this.form.actions.find((x) => x.id == id)));
            if (this.$refs.actionForm)
                this.$refs.actionForm.resetValidation();
            this.dialog = true;
        },
        submit() {
            this.loading = true;
            let form = JSON.parse(JSON.stringify(this.form));
            form.actions.forEach((el) => {
                delete el.id;
                if (!Array.isArray(el.users)) { el.users = [el.users] }
            });
            if (form.ticket_categories.find((x) => x == "other")) {
                form.ticket_categories.splice(form.ticket_categories.findIndex((x) => x == "other"), 1);
                form.other_ticket_category = true;
            } else form.other_ticket_category = false;
            this.$slaStore(form).then((res) => {
                if (res && res.status == 'CREATED') {
                    this.$toast.success(res.message);
                    this.$router.push({path: '/settings/sla'});
                }
            }).finally(()=>{this.loading = false});
        },
    },
    mounted() {
        this.$nextTick(async () => {
            this.$loading.start();
            if (this.$auth.user.full_admin)
                this.branches = this.$system.branches;
            this.importances = this.$system.importances;
            this.customerLevels = this.$system.customerLevels;
            await this.$system.setAdminDefaults();
            this.departments = this.$system.departmentsAdmin;
            this.$loading.finish();
        });
    },
};
</script>
